import { Box, Card, Flex, Label2 } from '@sainsburys-tech/fable'
import React from 'react'

interface IProps {
  title: string
  value: number | string
  className?: string
}

export const SummaryCard = (props: IProps) => (
  <Card
    orientation='vertical'
    className={props.className}
    contentAlignment='center'
    style={{
      minHeight: '120px',
      height: '100%',
      background: 'var(--fable-color-background-light,  #fff)',
    }}
  >
    <Flex
      direction='column'
      alignItems='center'
      justifyContent='center'
      style={{ height: '100%' }}
    >
      <Box
        as='div'
        style={{
          textAlign: 'center',
          color: 'var(--fable-color-text-primary, #000)',
          marginBottom: '8px',
        }}
        padding='none'
      >
        <Label2>{props.title}</Label2>
      </Box>
      <Box
        as='div'
        style={{
          textAlign: 'center',
          color: props.className,
        }}
        padding='none'
      >
        <Label2>{props.value}</Label2>
      </Box>
    </Flex>
  </Card>
)
